import clsx from 'clsx';
import Icon from 'components/Icon';
import {IconSize} from 'components/Icon/types';
import {FC} from 'react';

type CompanyToClientBlockProps = {
    clientName: string;
    iconSize?: IconSize;
    partnerName: string;
    showArrowRight?: boolean;
};

const CompanyToClientBlock: FC<CompanyToClientBlockProps> = ({
    clientName,
    iconSize = 'base',
    partnerName,
    showArrowRight,
}) => (
    <>
        <div className="flex min-w-0 flex-1 flex-wrap">
            <div className="min-w-0 whitespace-break-spaces break-words text-base font-semibold text-grey-800">
                {partnerName}
            </div>
            <div className="flex min-w-0">
                <Icon
                    className={clsx(
                        'mx-0.5 text-grey-600',
                        iconSize === 'base' ? 'my-1' : '',
                    )}
                    icon="arrow_right"
                    size={iconSize}
                />
                <div className="min-w-0 whitespace-break-spaces break-words text-base font-normal text-grey-600">
                    {clientName}
                </div>
            </div>
        </div>
        {showArrowRight && (
            <div className="flex items-center">
                <Icon className="text-grey-800" icon="small_arrow_right" />
            </div>
        )}
    </>
);

export default CompanyToClientBlock;
